const key = Symbol.for('vm2App.appConfig');

export const setAppConfig = (appConfig) => {
  window[key] = appConfig;
};

export const getAppConfig = () => window[key];
